export default function PHP_GET() {
  return (
    <div>
      <h1>PHP_GET</h1>
    </div>
  );
}
